export const environment = {
	production: false,
	//url: "https://api-mainsite.policystreet.com"
	url: "https://api-mainsite-enc.policystreet.app"
};
